<!-- MOBILE LAYOUT: ion-row/col wrappers -->
@if(isMobileLayout()) {

<ion-row class="ion-margin-top">
  <ion-col class="ion-padding-horizontal">
    <div class="text-muted">Step {{ step().step }} of 5</div>
    <div class="title mt-1 fw-bold">{{ step().title }}</div>
    @if (step().description) {
    <div class="step-desc text-justify my-2">{{ step().description }}</div>
    }
  </ion-col>
</ion-row>

<ion-row>
  @if (step().image) {
  <ion-col size="12" class="ion-no-padding ion-no-margin">
    <div class="d-flex flex-column">
      <div class="vehicle-image">
        <img [src]="step().image" alt="vehicleImg" />
      </div>
      @if(step().imgDescription) {
      <div class="fs-7 text-black text-justify mb-2 ion-padding-horizontal">{{step().imgDescription}}</div>
      }
    </div>
  </ion-col>
  }
  <ion-col size="12" class="d-flex flex-column ion-padding-horizontal">
    <ng-container [ngTemplateOutlet]="stepSections"></ng-container>
  </ion-col>
</ion-row>

} @else {

<!-- WEB LAYOUT: flat div structure -->
<div class="web-step-header">
  <div class="text-muted small">Step {{ step().step }} of 5</div>
  <div class="title mt-1 fw-bold">{{ step().title }}</div>
  @if (step().description) {
  <div class="step-desc text-justify mt-1">{{ step().description }}</div>
  }
</div>

<ng-container [ngTemplateOutlet]="stepSections"></ng-container>

}

<!-- Shared sections/options template used by both layouts -->
<ng-template #stepSections>
  @for (section of step().sections; track section.code ?? section.title ?? $index) {
  @if (section.options.length) {

  <div class="step-title fw-semibold" [class.mt-3]="!isMobileLayout()">{{ section.title }}</div>

  @if (step().step === 1) {
  <div class="border-top">
    @for (opt of section.options; track opt.label) {
    <div class="paint-option d-flex align-items-center py-2 my-2" tabindex="0" role="button"
      [class.active]="selectedPaint()?.label === opt.label" [attr.aria-pressed]="selectedPaint()?.label === opt.label"
      (click)="paintSelected.emit(opt)" (keydown.enter)="paintSelected.emit(opt)"
      (keydown.space)="paintSelected.emit(opt); $event.preventDefault()">
      <div class="d-flex align-items-center gap-2 ps-3 w-100">
        <div class="swatch" [ngClass]="!opt.primaryColor ? (opt.bgColorClass || 'swatch-default') : ''"
          [style.background]="opt.primaryColor"></div>
        <div class="paint-option-text">
          <div class="stepLabel">{{ opt.label }}</div>
          <div class="stepValue">{{ opt.price | currency:'GBP' }}</div>
        </div>
      </div>
    </div>
    }
  </div>
  }

  @else {
  <ion-accordion-group [class.border-top]="section.title">
    @for (opt of section.options; track opt.label) {
    <ion-accordion [value]="opt.label" class="my-3">
      <ion-item slot="header" class="option-card" [class.active]="isSelectedFn()(step(), section, opt)">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="d-flex align-items-center gap-2">
            <ion-checkbox mode="md" [checked]="isSelectedFn()(step(), section, opt)"
              (ionChange)="onCheckboxChange($event, section, opt)" (click)="$event.stopPropagation()">
            </ion-checkbox>
            <div class="d-flex flex-column py-2">
              @if (step().step === 5) {
              <span class="badge rounded-pill" [ngClass]="'badge-' + section.title?.toLowerCase()">
                {{ opt.label }}
              </span>
              } @else {
              <span class="stepAcclabel">{{ opt.label }}</span>
              }
              @if (opt.description) {
              <span class="stepDescrip text-justify m-1 me-4">{{ opt.description }}</span>
              }
            </div>
          </div>
          <div class="stepLabel">{{ opt.price | currency:'GBP' }}</div>
        </div>
      </ion-item>
    </ion-accordion>
    }
  </ion-accordion-group>
  }

  }
  }
</ng-template>